import styles from "./LoginForm.module.css";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import EmailInput from "../../../../components/Input/EmailInput/EmailInput";
import PasswordInput from "../../../../components/Input/PasswordInput/PasswordInput";
import SubmitButton from "../../../../components/Button/SubmitButton/SubmitButton";
import { useUserContext } from "../../../../context/UserContext";
import { login, verify } from "../../../../services/authService";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import Loader from "../../../../components/Loader/Loader";
import { log } from "../../../../utils/logger";

/**
 * Login form
 * Handles login.
 * @returns TSX.Element
 */
const LoginForm = () => {
    const { t } = useTranslation();
    const { setUserData, syncTokenFromCookie } = useUserContext();
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState<boolean>(false);

    const loginMutation = useMutation({
        mutationFn: async () => {
        setLoading(true);
        await login(email, password);     // cookie gets set here
        const userData = await verify();  // verify reads cookie
        return { userData };
        },
        onSuccess: ({ userData }) => {
        setLoading(false);
        setUserData(userData);

        syncTokenFromCookie();

        navigate("/order-settings");
        },
        onError: (error) => {
        log(error);
        setLoading(false);
        alert(t("login.login_failed"));
        },
    });

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (email === "" || password === "") {
        alert(t("login.missing_data"));
        return;
        }

        loginMutation.mutate();
    };

    return (
        <>
        {loading && <Loader text={t("login.loading")} />}
        <form className={styles.Form} onSubmit={handleSubmit}>
            <div className={styles.InputCapsule}>
            <EmailInput email={email} onChange={setEmail} />
            <PasswordInput password={password} onChange={setPassword} />
            </div>
            <div className={styles.FormLink}>
            <Link to="/forgot-password">{t("login.forgot_pass")}</Link>
            </div>
            <SubmitButton text={t("buttons.login")} disabled={loginMutation.isPending} />
        </form>
        </>
    );
};

export default LoginForm;
